module.exports = __webpack_public_path__ + "static/img/vue.1b411a70.svg";